<template>
  <div class="websocket-status" :class="`status-${status.toLowerCase()}`">
    <div class="status-indicator">
      <span class="status-dot"></span>
      <span class="status-text">{{ statusText }}</span>
    </div>

    <div v-if="error" class="status-error">
      {{ error }}
    </div>

    <div v-if="reconnectAttempts > 0" class="status-reconnect">
      Попытка переподключения: {{ reconnectAttempts }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useWebSocket } from '@/common/composables/useWebSocket'
import { WebSocketStatus } from '@/services/websocket/types'
import { computed } from 'vue'

const { status, error, reconnectAttempts } = useWebSocket()

const statusText = computed(() => {
  switch (status.value) {
    case WebSocketStatus.CONNECTED:
      return ''
    case WebSocketStatus.CONNECTING:
      return 'Подключение...'
    case WebSocketStatus.DISCONNECTED:
      return 'Отключено'
    case WebSocketStatus.RECONNECTING:
      return 'Переподключение...'
    case WebSocketStatus.ERROR:
      return 'Ошибка'
    default:
      return 'Неизвестно'
  }
})
</script>

<style scoped>
.websocket-status {
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.status-connected .status-dot {
  background-color: #10b981;
  box-shadow: 0 0 4px #10b981;
}

.status-connecting .status-dot,
.status-reconnecting .status-dot {
  background-color: #f59e0b;
  animation: pulse 1.5s ease-in-out infinite;
}

.status-disconnected .status-dot {
  background-color: #6b7280;
}

.status-error .status-dot {
  background-color: #ef4444;
}

.status-error {
  color: #ef4444;
  font-size: 11px;
}

.status-reconnect {
  color: #f59e0b;
  font-size: 11px;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}
</style>
